import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ThreeWordsService} from "../../services/3Words/three-words.service";
import {GeoLibService} from "../../services/geoLib/geo-lib.service";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {MapPosition} from "../../models/MapPosition";
import {Observable, Observer, of} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import {HttpServiceService} from "../../services/httpService/http-service.service";
// var focusLatLng = drawingManager.getMap().getCenter();
const typeHeadUrl = 'https://api.what3words.com/v3/autosuggest?key=MXCP10V7&language=en&format=json';
declare var Yiit;

@Component({
  selector: 'app-search-location',
  templateUrl: './search-location.component.html',
  styleUrls: ['./search-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class SearchLocationComponent implements OnInit{

  public Yiit = Yiit;

  constructor(private threeWords: ThreeWordsService,
              private geocoder: GeoLibService,
              private adapter: CesiumAdapterService,
              private http: HttpServiceService)
  { }

  isOpened: boolean = false;
  public suggestions$: Observable<any>;
  public search3Word:string;
  private current3WordBillboardEntityId = null;

  ngOnInit() {
    this.suggestions$ = new Observable((observer: Observer<string>) => {
      observer.next(this.search3Word);
    }).pipe(
      switchMap((query: string) => {
        if (query) {

          return this.http.sendOutsideGetRequest(this.getPreparedTypeHeadUrl(query))
            .pipe(
              map(data =>  data['suggestions'])
                // .map(item => item.words))
            )
        }
        return of([]);
      }));
  }


  toggleDropDown(){
    this.isOpened = !this.isOpened;
  }

  private getPreparedTypeHeadUrl(query){
    var parts = query.split('.');
    if (parts.length == 1) { query+= '..'; }
    if (parts.length == 2) { query+= '.'; }
    // '&focus=' + focusLatLng.lat() + ',' + focusLatLng.lng() +
    return typeHeadUrl+'&input=' + query;
  }

  checkForTouchedErrors(form: NgForm, controlName:string ){
    return form.invalid && form.controls.hasOwnProperty(controlName) && form.controls[controlName].touched;
  }

  searchLocation(form: NgForm){
    if (!form.valid){
      return;
    }

    window.focus();
    if (form.controls.hasOwnProperty('search3Word')){
      this.search3WordLocation(form.controls.search3Word.value);
    }
    else if(form.controls.hasOwnProperty('searchAddress')){
      this.searchAddressLocation(form.controls.searchAddress.value)
    }
  }

  private search3WordLocation(words) {
    let self = this;
    if (words.trim().length > 0) {
      var coordinates = this.threeWords.decode(words.trim());
      let destination = new MapPosition({lat: coordinates.lat, lng: coordinates.lng});
      destination.height += 500;
      this.adapter.moveCameraTo(destination);

      var template = [
        '<?xml version="1.0"?>',
        '<svg x="0" y="0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  width="1500" height="500" viewBox="0 0 1500 500">',
        '<rect stroke="#800" stroke-width="4" fill="#d70000" x="0" y="480" width="20" height="20" />',
        '<line x1="20" y1="480" x2="350" y2="150" stroke="black" stroke-width="2" />',
        '<line x1="350" y1="150" x2="1000" y2="150" stroke="black" stroke-width="2" />',
        '<text x="360" y="135" style="font-size:80px;">/// ' + words.trim() + '</text>',
        '<text x="440" y="220" style="font-size:80px;">incident</text>',
        '</svg>'
      ].join('\n');

      if (this.current3WordBillboardEntityId){
       this.adapter.removeObject(this.current3WordBillboardEntityId, ()=>{
         self.adapter.drawBillboardSVGImage({pos: new MapPosition({lat: coordinates.lat, lng: coordinates.lng}), svg: template}, (billboard)=>{
           this.current3WordBillboardEntityId = billboard;
           this.adapter.w3wBillboardId = billboard;
         })
       });
        return;
      }

      self.adapter.drawBillboardSVGImage({pos: new MapPosition({lat: coordinates.lat, lng: coordinates.lng}), svg: template}, (billboard)=>{
        this.current3WordBillboardEntityId = billboard;
        this.adapter.w3wBillboardId = billboard;
      })


      // var dataURL = canvas.toDataURL('image/png');
      // var data = atob(dataURL.substring('data:image/png;base64,'.length)),
      //   asArray = new Uint8Array(data.length);
      //
      // for (var i = 0, len = data.length; i < len; ++i) {
      //   asArray[i] = data.charCodeAt(i);
      // }

      // var blob = new Blob([asArray.buffer], {type: 'image/png'});
      // saveAs(blob, 'export_' + Date.now() + '.png');


      // var docMarker = new google.maps.Marker({
      //   position: coordinates,
      //   map: drawingManager.getMap(),
      //   title: 'Dynamic SVG Marker',
      //   icon: {
      //     url: ,
      //     anchor: new google.maps.Point(0, 200),
      //     scaledSize: new google.maps.Size(600, 200)
      //   },
      //   optimized: false
      // });

      // drawingManager.getMap().panBy(300, -100);
    }
  };

  private isAddress(str){
    let isAddressFlag = true;
    let stringSplitArr = str.split(',');
    if (stringSplitArr.length !== 2){
      return false;
    }
    stringSplitArr.forEach((str)=>{
      let strNum = +str;
      if (isNaN(strNum)){
        isAddressFlag = false;
      }
    });


    return isAddressFlag;
  }

  private searchAddressLocation(string){
    let self = this;
    if (this.isAddress(string)){
      let latLngsArr = string.split(',');
      let latLngs = {lat: latLngsArr[0], lng: latLngsArr[1]};
      let destination = new MapPosition(latLngs);
      destination.height += 500;
      self.adapter.moveCameraTo(destination);
      return;
    }
    if (string.trim().length > 0) {
      this.geocoder.geocoder.geocode({'address': string}, function(results, status) {
        if (status === 'OK') {
          // drawingManager.getMap().setCenter(results[0].geometry.location);
          let latLngs = self.getGoogleLatLng(results[0].geometry.location);
          let destination = new MapPosition({lat: latLngs.lat, lng: latLngs.lng});
          destination.height += 500;
          self.adapter.moveCameraTo(destination);
        } else {
          alert(Yiit.t("Can't find the address: ") + status);
        }
      });
    }
  }

  private getGoogleLatLng({lat, lng}){
    let result = {lat: lat, lng: lng};
    if (typeof lat == 'function'){
      result.lat = lat();
    }

    if (typeof lng == 'function'){
      result.lng = lng();
    }

    return result;
  }

}
